// client/src/pages/FAQ.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function FAQ() {
  const [content, setContent] = useState('');

  useEffect(() => {
    // fetch the "faq" page content
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/pages/faq`)
      .then((res) => {
        setContent(res.data.content);
      })
      .catch((err) => console.error('Error fetching FAQ page:', err));
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-4 mt-16">
      <h1 className="text-3xl font-bold mb-4">Frequently Asked Questions</h1>
      <div
        className="leading-relaxed text-gray-700 quill-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
